import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { GbGemeindeId } from 'app/core/amtlichebewertung-api';
import { EMPTY, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { CapAlertService } from 'app/core/extension/exceptions/cap-alert.service';
import { CapExceptionHandler } from 'app/core/extension/exceptions/cap-exception-handler';
import { ResolverValidationExceptionHandler } from '../../../../core/extension/exceptions/exception-handler-rule';
import { AuftragSearchResponseMeta, BatchAuftragService } from 'app/core/batch-auftrag-api';
import { CapAlertLevel } from '../../../../core/extension/exceptions/cap-alert-level.enum';

@Injectable()
export class AuftragListResolver {
  readonly GEMEINDE_ID_PARAMETER_NAME = 'gemeindeId';

  constructor(
    private translate: TranslateService,
    private batchAuftragService: BatchAuftragService,
    private exceptionHandler: CapExceptionHandler,
    private capAlertService: CapAlertService,
    private resolverValidationExceptionHandler: ResolverValidationExceptionHandler
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AuftragSearchResponseMeta> {
    const request = route.queryParamMap.get('request');
    return this.loadData(request);
  }

  getGemeindeId(id: string): GbGemeindeId {
    return { id };
  }

  private loadData(lastSearchRequest): Observable<AuftragSearchResponseMeta> {
    if (!lastSearchRequest) {
      return;
    }
    if (lastSearchRequest) {
      const request = JSON.parse(lastSearchRequest);
      return this.batchAuftragService.searchAuftrag(request).pipe(
        switchMap((response) => {
          if (response.recordsFound === 0) {
            this.capAlertService.info(this.translate.instant('KeineResultateGefunden'));
            return EMPTY;
          } else {
            return of(response);
          }
        }),
        tap((r) =>
          r.tooManyRecordsFound
            ? this.capAlertService.warning(
                this.translate.instant('MaximalResultWarningKeineEinschraenkung', {
                  maxDisplayableRecords: r.maxDisplayableRecords,
                  recordsFound: r.recordsFound
                }),
                CapAlertLevel.CONTENT_HEADER,
                true
              )
            : null
        ),
        catchError((err) => this.handleError(err))
      );
    }
  }

  private handleError(err) {
    if (err.status === 404) {
      this.capAlertService.info(this.translate.instant('KeineResultateGefunden'));
      return EMPTY;
    } else if (this.resolverValidationExceptionHandler.errorHandled(err)) {
      return EMPTY;
    }
    this.exceptionHandler.handleError(err);
    return EMPTY;
  }
}
